module.exports = __webpack_public_path__ + "img/Klank-Kleur_WebV2.12871a01.png";